import React, { useEffect, useState } from "react";
import { DownloadIcon, FileImageIcon } from "lucide-react";

interface DownloadSectionProps {
  fileUrls: string[];
}

type FileDetail = {
  name: string;
  size: string;
  format: string;
};

const DownloadSection: React.FC<DownloadSectionProps> = ({ fileUrls }) => {
  const [fileDetails, setFileDetails] = useState<FileDetail[]>([]);

  useEffect(() => {
    const fetchFileDetails = async () => {
      try {
        const details = await Promise.all(
          fileUrls.map(async (url) => {
            const response = await fetch(url);
            const blob = await response.blob();
            const fileName = url.split("/").pop() || "unknown";
            const fileSize = (blob.size / 1024).toFixed(1) + "KB";
            const fileFormat =
              fileName.split(".").pop()?.toUpperCase() || "UNKNOWN";

            return {
              name: fileName,
              size: fileSize,
              format: fileFormat,
            };
          })
        );
        setFileDetails(details);
      } catch (error) {
        console.error("Error fetching file details:", error);
      }
    };

    fetchFileDetails();
  }, [fileUrls]);

  return (
    <div>
      {fileDetails.map((file, index) => (
        <div
          key={index}
          className="flex items-center p-2 border-t border-gray-200 w-1/2"
        >
          <div className="flex items-center space-x-3">
            <div
              className="flex-shrink-0 text-gray-500 rounded-full border border-gray-200 p-1"
              style={{ borderWidth: "1.5px" }}
            >
              <FileImageIcon size={18} />
            </div>
            <div>
              <p className="text-sm font-bold">{file.name}</p>
              <p className="text-xs text-gray-500">
                {file.format} · {file.size}
              </p>
            </div>
          </div>
          <a
            href={fileUrls[index]}
            download
            className="text-blue-500 hover:text-blue-700 ml-4 border border-gray-200 p-1 rounded"
            style={{ borderRadius: "6px" }}
          >
            <DownloadIcon size={16} />
          </a>
        </div>
      ))}
    </div>
  );
};

export default DownloadSection;
